import script from "./DeactivateView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeactivateView.vue?vue&type=script&lang=ts&setup=true"

import "./DeactivateView.vue?vue&type=style&index=0&id=64158561&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64158561"]])

export default __exports__